function OffenderProfile() {
    "use strict";

    this.__type = 'OffenderProfile:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.Email = '';
    this.EyeColorId = -1;
    this.GenderId = -1;
    this.HairColorId = -1;
    this.Height = 0;
    this.IsSexOffender = false;
    this.MarksTattoos = '';
    this.PrimaryJurisdiction = '';
    this.PrimaryOffenseId = -1;
    this.RaceId = -1;
    this.SupervisionBeginDate = new Date(-62135596800000);
    this.SupervisionEndDate = new Date(-62135596800000);
    this.SupervisionTypeId = -1;
    this.TimeZoneCode = '';
    this.VehicleColor = 'Unknown';
    this.VehicleMake = 'UNKNOWN';
    this.VehicleModel = '';
    this.VehiclePlateNumber = '';
    this.VehicleYear = 0;
    this.Weight = 0;
    this.DailyRate = -1;
    this.SecurusEnrolleePayId = -1;
    this.OrganizationAddressId = 0;
    this.HasAssociationFlag = false;
    this.GuardianName = '';
    this.GuardianPhone = '';
    this.GuardianEmail = '';
    this.TransactionId = '';
    this.IsNewEnrollee = 0;
}
if (typeof exports !== 'undefined') {
    module.exports = OffenderProfile;
}